import { useContext, useState } from 'react';

import { Separator } from '@swyftx/aviary/atoms/Seperator';
import { CloseMenu } from '@swyftx/aviary/icons/outlined';
import { MenuItem } from '@swyftx/aviary/molecules/Menu';

import { UIStore } from '@shared/store';
import { cn } from '@shared/utils/lib/ui';

import { observer } from 'mobx-react-lite';
import { UIContext } from 'src/lib/utils/context/UI.context';

import Items from '../components/Items';
import { useAppSideBar } from '../useAppSideBar';

const DesktopSidebar = observer(function DesktopSidebar() {
  const { navDrawerPinned, setNavDrawerPinned, setNavDrawerOpen, showMarketTicker } = UIStore.useUIStore;
  const { openOnHover } = useContext(UIContext);
  const { state } = useAppSideBar();
  const [isHovering, setIsHovering] = useState(false);

  const open = isHovering || state === 'docked';

  const expand = () => {
    if (state === 'overlay') {
      setIsHovering(!open);
      return;
    }

    setNavDrawerPinned(!navDrawerPinned);
    setNavDrawerOpen(false);
  };

  const handleMouse = (value: boolean) => {
    if (openOnHover) {
      setIsHovering(value);
    }
  };

  return (
    <div className={cn(!navDrawerPinned && ' min-w-[62px]')}>
      <aside
        // This uses pure style defs to ensure that the sidebar width responds to the css transition property,
        // for some reason tw classes changes weren't transition correctly
        style={{ width: open ? 'var(--sidebar-width-desktop-opened)' : '62px' }}
        className={cn(
          'no-scrollbar z-30 grid content-start gap-8 overflow-x-hidden border-r border-color-border-main bg-color-background-surface-primary p-8 pb-80 transition-[width] duration-150',
          !navDrawerPinned && 'absolute',
          showMarketTicker ? 'h-[calc(100vh-96px)]' : 'h-[calc(100vh-64px)]',
        )}
        onMouseEnter={() => handleMouse(true)}
        onMouseLeave={() => handleMouse(false)}
      >
        <MenuItem
          className={`p-12 ${open ? '' : 'w-46 overflow-hidden'}`}
          text={open ? 'Collapse Menu' : ''}
          icon={<CloseMenu className={cn('text-color-text-primary', !open && 'rotate-180')} />}
          action={expand}
        />
        <Separator className={cn('transition-opacity duration-150', !open ? 'opacity-0' : 'opacity-1')} />
        <Items collapsed={!open} />
      </aside>
    </div>
  );
});

export default DesktopSidebar;
